import { render } from "./Examen_ElemExam.vue?vue&type=template&id=efaa8112"
import script from "./Examen_ElemExam.vue?vue&type=script&lang=js"
export * from "./Examen_ElemExam.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__